import axiosClient from "api/axiosClient";
import API_MAP from "constants/api";
import { ERROR_CODE_GROUP, ERROR_CODE_GROUP_USERS, ERROR_CODE_REMOVE_GROUP, ERROR_CODE_REMOVE_GROUP_USERS } from "constants/errorCode";
import i18n from "i18n";
import { toastError } from "utils/helpers";

export const groupUsersService = {
    addGroup: async (data) => {
        try {
            const res = await axiosClient.post(API_MAP.GROUPS.ADD_GROUP, data);

            if (res.code !== 0) return toastError(i18n.t(ERROR_CODE_GROUP[res.code]))

            return res
        } catch (error) {
            console.log(error)
        }
    },
    addMemberGroup: async (data) => {
        try {
            const res = await axiosClient.post(API_MAP.GROUPS.ADD_MEMBER, data);

            if (res.code !== 0) return toastError(i18n.t(ERROR_CODE_GROUP_USERS[res.code]))

            return res
        } catch (error) {
            console.log(error)
        }
    },
    getGroupUsers: async (params) => {
        try {
            const res = await axiosClient.get(API_MAP.GROUPS.GETS, { params })

            return res
        } catch (error) {
            console.log(error)
        }
    },
    getDetailGroupUsers: async (params) => {
        try {
            const res = await axiosClient.get(API_MAP.GROUPS.MEMBER_LIST, { params })

            return res
        } catch (error) {
            console.log(error)
        }
    },
    removeGroup: async (groupId) => {
        try {
            const res = await axiosClient.get(API_MAP.GROUPS.REMOVE_GROUP + groupId);

            if (res.code !== 0) return toastError(i18n.t(ERROR_CODE_REMOVE_GROUP[res.code]))

            return res
        } catch (error) {
            console.log(error)
        }
    },
    removeMemberGroup: async (data) => {
        try {
            const res = await axiosClient.post(API_MAP.GROUPS.REMOVE_MEMBER, data);

            if (res.code !== 0) return toastError(i18n.t(ERROR_CODE_REMOVE_GROUP_USERS[res.code]))

            return res
        } catch (error) {
            console.log(error)
        }
    },
    updateGroup: async (groupId, data) => {
        try {
            const res = await axiosClient.post(API_MAP.GROUPS.UPDATE_GROUP + groupId, data);

            if (res.code !== 0) return toastError(i18n.t(ERROR_CODE_GROUP_USERS[res.code]))

            return res
        } catch (error) {
            console.log(error)
        }
    }
}